import { Flex } from '../atoms';
import { OverviewPageHeader } from '../molecules';

export function CenteredScreen({
  title,
  headerActions,
  children,
  noHeader = false
}: {
  title?: string;
  noHeader?: boolean;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <Flex
      width="100vw"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      {!noHeader && (
        <OverviewPageHeader title={title} width="inherit">
          {headerActions}
        </OverviewPageHeader>
      )}
      <Flex
        flex={1}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        {children}
      </Flex>
    </Flex>
  );
}
